import Vue from "vue"
const Order = {
  state: {
    allshow: false,
    states: "",
    fbaStates: "",
    orderDetail: {},
    edit: false
  },
  getters: {
    getOrderDetail: state => {
      if (Vue.ls.get("orderDetail")) {
        state.orderDetail = Vue.ls.get("orderDetail")
        return state.orderDetail
      } else {
        return state.orderDetail
      }
    }
  },
  mutations: {
    change: state => {
      state.allshow = !state.allshow
    },
    changeEdit: state => {
      state.edit = !state.edit
    },
    stateChange: (state, states) => {
      state.states = states
    },
    fbaStateChange: (state, fbaStates) => {
      state.fbaStates = fbaStates
    },
    SET_ORDERDETAIL: (state, item) => {
      state.orderDetail = item
      Vue.ls.set("orderDetail", item)
    }
  },
  actions: {}
}
export default Order
